import * as React from "react";

import {
  ReactCheckout2022Route,
  useDrawerDelivery_asController,
  useMyBagPresentationModel,
  useReactCheckout2022Router,
} from "../providers";

import { HeaderDeliveryTouchpointPortal } from "./header-delivery-touchpoint-portal";

export const HeaderDeliveryTouchpoint: React.FunctionComponent = (props) => {
  const { currentRoute } = useReactCheckout2022Router();
  const { presentationMyBagOrder } = useMyBagPresentationModel();
  const { handleOpen: drawerDelivery_handleOpen } =
    useDrawerDelivery_asController();

  if (
    !presentationMyBagOrder ||
    currentRoute === ReactCheckout2022Route.mybag
  ) {
    return null;
  }
  return (
    <HeaderDeliveryTouchpointPortal>
      <a
        className="header-delivery-touchpoint bbnt-uses-page-width-max--from-the-inside"
        href="javascript:void(0)"
        onClick={drawerDelivery_handleOpen}
      >
        <span className="show-order-delivery-text">{`Show order summary`}&nbsp;</span>
        <span className="dollar-sign">{`\$`}</span>
        <span className="dollar-value">
          {presentationMyBagOrder?.totalValueBreakdown.value.toFixed(2)}
        </span>
      </a>
    </HeaderDeliveryTouchpointPortal>
  );
};
